import { Component, inject, OnInit } from '@angular/core';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageRepo } from '../languages/language.repo';
import { ThemeService } from '@shared/services/themeService/theme.service';
import { AuthStoreService } from '@features/auth/infrastructure/services/auth-store/auth-store.service';
import { AuthApiService } from '@features/auth/infrastructure/services/auth-api/auth-api.service';
import { Router, RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { MenuModalComponent } from './menu-modal/menu-modal.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { UserModalComponent } from './user-modal/user-modal.component';
import { UnsubscribeService } from '@shared/services/unsubscribe.service';
import { takeUntil } from 'rxjs';
import { RolePermissionService } from '@shared/services/role-permission.service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [
    NgbDropdownModule,
    NgClass,
    RouterLink,
    TranslocoDirective
],
  providers: [
    UnsubscribeService,
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent implements OnInit {
  user = this.authStoreService.user();
  private modalService = inject(NgbModal);
  private unsub = inject(UnsubscribeService);
  #rolePermissionService = inject(RolePermissionService);

  constructor(protected langRepo: LanguageRepo,
              private themeService: ThemeService,
              private authStoreService: AuthStoreService,
              private authApiService: AuthApiService,
              private router: Router,
  ) {
  }

  ngOnInit(): void {
  }

  openMenuModal() {
    this.modalService.open(MenuModalComponent, { fullscreen: true });
  }

  openUserModal() {
    this.modalService.open(UserModalComponent, { fullscreen: true });
  }

  logout() {
    this.authApiService.logout(this.authStoreService.refreshToken()!).pipe(takeUntil(this.unsub.$unsub)).subscribe(() => {
      this.authStoreService.logout();
      this.router.navigate(['/auth']);
    });
  }

  changeTheme() {
    if (this.themeService.theme() == 'dark') {
      this.themeService.theme.set('light');
    } else {
      this.themeService.theme.set('dark');
    }
  }

  getUserName() {
    return this.user?.firstname || this.user?.username || '';
  }

  isRoutePermitted(route: string) {
    return this.#rolePermissionService.isRoutePermitted(route);
  }

}
